import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Languages, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from '../../../../shared/services/global.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { ETenderDTO, ETenderAttachmentType, ETendersAttachmentDTO, CategoryDTO, SupplierDTO, SPGroupUserDTO, ETendersCategoriesAdminDTO, ETenderSupplierDTO, ETenderTypes, Speciality, SupplierSpecialityDTO, ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import * as deepEqual from 'deep-equal';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
import { SupplierService } from 'src/app/shared/services/supplier.service';

@Component({
  selector: 'app-create-tender',
  templateUrl: './create-tender.component.html',
  styles: []
})
export class CreateTenderComponent implements OnInit {
  @ViewChild('createTender',{static: false}) createTender: ElementRef;
  formMode: FormMode;
  FormMode: any = FormMode;
  today = new Date(new Date().setDate(new Date().getDate() + 1));
  createTenderForm: FormGroup;
  languages: LookUp[];
  TenderTypes: LookUp[];
  TenderMethods: LookUp[];
  displayedLang: string;
  model: ETenderDTO;
  responseObj: ResponseObject;
  numberRegex = '^[0-9]*$';
  ArabicRegex = '^[\u0600-\u06FF0-9 ]+$';
  EnglishRegex = '[a-zA-Z0-9 ]*';
  submitted = false;
  showRequest = true;
  BookletProgress: number;
  CteateTenderAttachments: ETendersAttachmentDTO[] = [];
  TenderType: number;
  language: number;
  booleans = [{ Id: false, NameEN: 'No', NameAR: 'لا' },
  { Id: true, NameEN: 'Yes', NameAR: 'نعم' }];
  EvaluationSystems: LookUp[];
  dropdownSettings = {};
  suppliersDropdownSettings = {};
  adminsDropdownSettings = {};
  categoriesList: CategoryDTO[];
  suppliersList: SupplierDTO[] = [];
  SpecialitiesList: Speciality[];
  TechnicalAdminsList: ETendersCategoriesAdminDTO[];
  PurchasingAdminsList: ETendersCategoriesAdminDTO[];
  TechnicaloAdminsOriginalList: ETendersCategoriesAdminDTO[];
  PurchasingAdminsOriginalList: ETendersCategoriesAdminDTO[];
  ETenderManagers: SPGroupUserDTO[];
  ETenderCategories: ETendersCategoriesAdminDTO[];
  oldCats: number[];
  oldSpecs: number[];
  showStartDateGreaterThanOfferDeadLineMessage: Boolean = false;
  showEndDateGreaterThanOfferDeadLineMessage: Boolean = false;
  showStartDateGreaterThanEndDateMessage: Boolean = false;
  showPublishDateGreaterThanOfferDeadLineMessage: Boolean = false;
  showPublishDateGreaterThanStartDateMessage: Boolean = false;
  showPublishDateGreaterThanEndDateMessage: Boolean = false;
  message: string;
  private tenderRequestId = '';
  private fileNumber = '';
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl + AppConfig.settings.apiServer.ETenderUploadsFolder + '/';
  booklet: ETendersAttachmentDTO = new ETendersAttachmentDTO();
  cancellationDoc: ETendersAttachmentDTO = new ETendersAttachmentDTO();
  @Output() tenderRequestLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  regexpNumber: RegExp = new RegExp('^(?!.*[<])');
  MinPublishDate: Date = new Date();
  MinClarificationStartDate: Date = new Date();
  MinClarificationEndDate: Date = new Date();
  MinDeadlineDate: Date = new Date();
  MinTenderDate: Date = new Date();
  MinFinancialYear: Date = new Date();
  isSupplierAvailabale = false;
  isAdmin;
  showClarification: Boolean = false;
  UnAuthorized: boolean;
  IsSuccess = false;

  constructor(
    private route: ActivatedRoute, private authSrevice: AuthenticationService,
    private alertService: AlertService, private supplierService: SupplierService,
    private formBuilder: FormBuilder,
    private etenderSrv: EtenderService,
    private lookupService: LookupService,
    private globalSrv: GlobalServices,
    private fileService: fileService,
    private translate: TranslateService) {
    this.isAdmin = this.authSrevice.currentUserValue.IsAdmin;
    // this.isAdmin = this.globalSrv.user.IsAdmin;
    this.isSupplierAvailabale = history.state.data != undefined && history.state.data.supplierId != undefined;

    if (history.state.data && history.state.data.FileNumber) {
      this.fileNumber = history.state.data.FileNumber;
    }
    if (history.state.data && history.state.data.tenderId) {
      this.tenderRequestId = history.state.data.tenderId;
    } else if (history.state.data && history.state.data.requestId) {
      this.tenderRequestId = history.state.data.requestId;
    }

    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true
    };
    this.suppliersDropdownSettings = {
      singleSelection: false,
      idField: 'UserId',
      textField: 'CompanyName',
      selectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true
    };
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'SPGroupUserId',
      textField: 'SPGroupUserName',
      selectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: false
    };
  }

  get TitleARFormContol(): FormControl { return this.createTenderForm.get('TitleAR') as FormControl; }
  get TitleENFormContol(): FormControl { return this.createTenderForm.get('TitleEN') as FormControl; }
  get SessionPlaceARFormContol(): FormControl { return this.createTenderForm.get('SessionPlaceAR') as FormControl; }
  get SessionPlaceENFormContol(): FormControl { return this.createTenderForm.get('SessionPlaceEN') as FormControl; }
  get GeneralTermsARFormContol(): FormControl { return this.createTenderForm.get('GeneralTermsAR') as FormControl; }
  get GeneralTermsENFormContol(): FormControl { return this.createTenderForm.get('GeneralTermsEN') as FormControl; }
  get CommentsArFormContol(): FormControl { return this.createTenderForm.get('CommentsAr') as FormControl; }
  get CommentsEnFormContol(): FormControl { return this.createTenderForm.get('CommentsEn') as FormControl; }
  get MinimumAcceptancePointsForTechnicalOfferFormContol(): FormControl { return this.createTenderForm.get('MinimumAcceptancePointsForTechnicalOffer') as FormControl; }
  ngOnInit() {

    this.buildForm(0);
    this.loadLookups();
  }
  // Form Mode
  setFormMode(): void {
    if (this.tenderRequestId != '') {
      this.formMode = FormMode.Edit;
      if (this.isAdmin != true) {
        this.formMode = FormMode.Readonly;
      }
      this.globalSrv.isLoaderEnabled = true;
      this.getTenderRequest();
    } else if (this.fileNumber != '') {
      this.formMode = FormMode.Readonly;
      this.globalSrv.isLoaderEnabled = true;
      this.getTenderRequestByFileNumber();
    } else {
      this.etenderSrv.GetUserGroups(this.authSrevice.currentUserValue.Email).subscribe(
        async data => {
          const userGroups: number[] = data.Data;
          if (userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderPurchasingCategoryAdmins ||
            a == ETenderAdminTypes.SCAServices_ETenderCreators).length > 0) {
            this.formMode = FormMode.Add;
          } else {
            this.showRequest = false;
            this.alertService.error(await this.translate.get('ADMIN_USER.E_TENDER_FORM.UNAUTHORIZE').toPromise());
          }
        });
    }
  }
  getTenderRequestByFileNumber() {
    this.etenderSrv.GetTenderRequestByFileNumber(this.fileNumber).subscribe(
      data => {
        this.responseObj = data;
        this.getTenderRequestCompleted();
      },
      () => console.log('Something went wrong!!')
    );
  }
  getTenderRequest(): void {
    this.etenderSrv.GetTenderById(this.tenderRequestId).subscribe(
      data => {
        this.responseObj = data;
        this.getTenderRequestCompleted();
      },
      () => console.log('Something went wrong!!')
    );
  }
  getTenderRequestCompleted(): void {
    if (this.responseObj.Success) {
      this.model = this.responseObj.Data as ETenderDTO;
      this.tenderRequestLoadedFlag.emit(true);
      if (this.model.Status == 2 || this.model.Status == 4) {
        this.formMode = FormMode.Readonly;
      }
      if (this.model.PublishingDate != null) {
        this.model.PDTime = new Date(this.model.PublishingDate);
        this.model.PD = new Date(this.model.PublishingDate);
        if (this.MinPublishDate > new Date(this.model.PD.setHours(0))) {
          this.MinPublishDate.setDate(this.model.PD.setHours(0));
        }
      }
      if (this.model.ClarificationDurationEndDate != null) {
        this.model.CDEndDateTime = new Date(this.model.ClarificationDurationEndDate);
        this.model.CDEndDate = new Date(this.model.ClarificationDurationEndDate);
        if (this.MinClarificationEndDate > new Date(this.model.CDEndDate.setHours(0))) {
          this.MinClarificationEndDate = this.model.CDEndDate;
        }
      }
      if (this.model.OfferDeadline != null) {
        this.model.ODTime = new Date(this.model.OfferDeadline);
        this.model.OD = new Date(this.model.OfferDeadline);
        if (this.MinDeadlineDate > new Date(this.model.OD.setHours(0))) {
          this.MinDeadlineDate = this.model.OD;
        }
      }
      if (this.model.ClarificationDurationStartDate != null) {
        this.model.CDStartDateTime = new Date(this.model.ClarificationDurationStartDate);
        this.model.CDStartDate = new Date(this.model.ClarificationDurationStartDate);
        if (this.MinClarificationStartDate > new Date(this.model.CDStartDate.setHours(0))) {
          this.MinClarificationStartDate = this.model.CDStartDate;
        }
        this.showClarification = this.isGreaterThanDate(new Date(), this.model.CDStartDateTime) &&
          this.isGreaterThanDate(this.model.CDEndDateTime, new Date());
      }
      if (this.model.FinancialYear != null) {
        this.model.FinancialYear = new Date(this.model.FinancialYear);
        if (this.MinFinancialYear > this.model.FinancialYear) {
          this.MinFinancialYear = this.model.FinancialYear;
        }
      }
      if (this.model.Time != null) {
        this.model.Time = new Date(this.model.Time);
      }
      if (this.model.Date != null) {
        if (this.MinTenderDate > new Date(new Date(this.model.Date).setHours(0))) {
          this.MinTenderDate = new Date(this.model.Date);
        }
      }
      this.TenderType = this.model.TenderTypeId;
      this.language = this.model.Language;
      if (this.model.ETendersAttachments[0] != null) {
        this.booklet = this.model.ETendersAttachments.filter(a => a.AttachmentTypeId == ETenderAttachmentType.Booklet)[0];
        if (this.booklet != undefined) {
          this.booklet.URL = this.uploadUrl + this.booklet.URL;
          const BookletCopy = this.Validate.Booklet;
          BookletCopy.clearValidators();
          BookletCopy.setValue('');
          BookletCopy.updateValueAndValidity();
        }
        this.cancellationDoc = this.model.ETendersAttachments
          .filter(a => a.AttachmentTypeId == ETenderAttachmentType.CancellationAttachment)[0];
        if (this.cancellationDoc != undefined) {
          this.cancellationDoc.URL = this.uploadUrl + this.cancellationDoc.URL;
        }
      }
      this.model.ETendersCategories = this.model.ETendersCategoriesAdmin
        .filter((thing, i, arr) => arr.findIndex(t => t.CategoryId === thing.CategoryId) === i)
        .map(function (e) { return e.Category; });
      this.model.TechnicalAdmins = [];
      this.model.PurchasingAdmins = [];
      this.oldCats = this.model.ETendersCategories.map(function (e) {
        return e.Id;
      });
      if (this.model.TenderTypeId != ETenderTypes.PublicBidding) {
        for (const i of this.model.ETendersCategoriesAdmin) {
          if (i.SPGroupUser != null) {
            i.SPGroupUserName = i.SPGroupUser.Username;
            if (this.model.TechnicalAdmins.filter(a => a.SPGroupUserId === i.SPGroupUserId).length === 0 && i.SPGroupUser.SPGroupId === 18) {
              this.model.TechnicalAdmins.push({
                Category: null, CategoryId: i.CategoryId,
                SPGroupUserId: i.SPGroupUserId, ETenderId: null, Id: '', SPGroupUser: null, SPGroupUserName: i.SPGroupUserName
              });
            }
            if (this.model.PurchasingAdmins.filter(a => a.SPGroupUserId === i.SPGroupUserId).length === 0 && i.SPGroupUser.SPGroupId === 19) {
              this.model.PurchasingAdmins.push(i);
            }
          }
        }

        this.buildForm(1);
        this.GetCategoriesDataByIds();
      } else {
        this.buildForm(1);
        this.globalSrv.isLoaderEnabled = false;
      }
      // Disable Loader
    } else {
      // Enable Error
    }
  }

  GetCategoriesDataByIds() {
    this.etenderSrv.GetCategoriesDataByIds(this.oldCats).subscribe(c => {
      this.SpecialitiesList = c.Data.Specialities;
      if (this.model != null && this.model.ETenderSuppliers != null && this.model.ETenderSuppliers.length > 0
        && (this.TenderType == ETenderTypes.LimitedTender || this.TenderType == ETenderTypes.Practice)) {
        const specialityIds: number[] = [];
        for (let i = 0; i < this.model.ETenderSuppliers.length; i++) {
          for (let j = 0; j < this.model.ETenderSuppliers[i].Supplier.SupplierSpecialities.length; j++) {
            specialityIds.push(this.model.ETenderSuppliers[i].Supplier.SupplierSpecialities[j].SpecialityId);
          }
        }
        this.model.Specialities = this.SpecialitiesList.filter(e => specialityIds.includes(e.Id));
        this.buildForm(1);
        // this.SpecialitiesChanged();
      }
      this.TechnicaloAdminsOriginalList = c.Data.TechnicalAdmins;
      this.PurchasingAdminsOriginalList = c.Data.PurchasingAdmins;
      this.TechnicalAdminsList = c.Data.TechnicalAdmins.
        filter((thing, i, arr) => arr.findIndex(t => t.SPGroupUserId === thing.SPGroupUserId) === i);
      this.PurchasingAdminsList = c.Data.PurchasingAdmins.
        filter((thing, i, arr) => arr.findIndex(t => t.SPGroupUserId === thing.SPGroupUserId) === i);
      this.globalSrv.isLoaderEnabled = false;
      const element: HTMLElement = document.getElementsByTagName('Html')[0] as HTMLElement;
      element.click();
    });
  }
  buildForm(mode: number) {
    if (mode === 0 && this.TenderType != null) {
      this.model = this.createTenderForm.getRawValue();
    }
    if (this.TenderType == null) {
      this.createTenderForm = this.formBuilder.group({
        Id: [''],
        Language: [null, [Validators.required]],
        TenderTypeId: [null, [Validators.required]],
        TitleAR: [''],
        TitleEN: [''],
        SessionPlaceAR: [''],
        SessionPlaceEN: [''],
        Booklet: [''],
        ETendersCategories: [null],
        TechnicalAdmins: [null],
        PurchasingAdmins: [null],
        ETenderSuppliers: [null],
        ETenderSpecialities: [null],
        PublishingDate: [''],
        PD: ['', [Validators.required]],
        PDTime: ['', [Validators.required]],
        CreatedBy: [''],
        CreationDate: [''],
        ETenderCreatorId: [''],
      });
    }
    if (this.TenderType == ETenderTypes.PublicTender) {
      this.createTenderForm = this.formBuilder.group({
        Id: [this.model.Id],
        Language: [this.language, [Validators.required]],
        TenderTypeId: [this.TenderType, [Validators.required]],
        TitleAR: [this.model.TitleAR],
        TitleEN: [this.model.TitleEN],
        SessionPlaceAR: [this.model.SessionPlaceAR],
        SessionPlaceEN: [this.model.SessionPlaceEN],
        TenderNumber: [this.model.TenderNumber, [Validators.required, Validators.maxLength(250), this.globalSrv.noWhitespaceValidator, Validators.pattern(this.regexpNumber)]],
        FileNumber: [this.model.FileNumber, [Validators.required, Validators.maxLength(250), this.globalSrv.noWhitespaceValidator, Validators.pattern(this.regexpNumber)]],
        FinancialYear: [this.model.FinancialYear, [Validators.required]],
        OD: [this.model.OD, [Validators.required]],
        ODTime: [this.model.ODTime, [Validators.required]],
        OfferDeadline: [''],
        PrimaryInsuranceValue: [this.model.PrimaryInsuranceValue, [Validators.maxLength(250)]],
        Booklet: ['', [FileValidator.validate]],
        TenderMethodId: [this.model.TenderMethodId, [Validators.required]],
        HaveMaintenanceContract: [this.model.HaveMaintenanceContract, [Validators.required]],
        MaintenanceContractValue: [this.model.MaintenanceContractValue],
        AcceptRetail: [this.model.AcceptRetail, [Validators.required]],
        HaveAlternativeOffers: [this.model.HaveAlternativeOffers, [Validators.required]],
        EvaluationSystemId: [this.model.EvaluationSystemId, [Validators.required]],
        MinimumAcceptancePointsForTechnicalOffer: [this.model.MinimumAcceptancePointsForTechnicalOffer],
        ETendersCategories: [this.model.ETendersCategories, [Validators.required]],
        CommentsAr: [this.model.CommentsAr],
        CommentsEn: [this.model.CommentsEn],
        ETenderManagerId: [this.model.ETenderManagerId, [Validators.required]],
        TechnicalAdmins: [this.model.TechnicalAdmins, [Validators.required]],
        PurchasingAdmins: [this.model.PurchasingAdmins, [Validators.required]],
        ETenderSuppliers: [null],
        ETenderSpecialities: [null],
        ClarificationDurationStartDate: [''],
        CDStartDate: [this.model.CDStartDate, [Validators.required]],
        CDStartDateTime: [this.model.CDStartDateTime, [Validators.required]],
        ClarificationDurationEndDate: [''],
        CDEndDate: [this.model.CDEndDate, [Validators.required]],
        CDEndDateTime: [this.model.CDEndDateTime, [Validators.required]],
        PublishingDate: [''],
        PD: [this.model.PD, [Validators.required]],
        PDTime: [this.model.PDTime, [Validators.required]],
        CreatedBy: [this.model.CreatedBy],
        CreationDate: [this.model.CreationDate],
        ETenderCreatorId: [this.model.ETenderCreatorId],
        CancellationReason: [this.model.CancellationReason],
        Status: [this.model.Status],
        IsNotoficationSent: [this.model.IsNotoficationSent],
      });
    }
    if (this.TenderType == ETenderTypes.LimitedTender) {
      this.createTenderForm = this.formBuilder.group({
        Id: [this.model.Id],
        Language: [this.language, [Validators.required]],
        TenderTypeId: [this.TenderType, [Validators.required]],
        TitleAR: [this.model.TitleAR],
        TitleEN: [this.model.TitleEN],
        SessionPlaceAR: [this.model.SessionPlaceAR],
        SessionPlaceEN: [this.model.SessionPlaceEN],
        TenderNumber: [this.model.TenderNumber, [Validators.required, Validators.maxLength(250), this.globalSrv.noWhitespaceValidator, Validators.pattern(this.regexpNumber)]],
        FileNumber: [this.model.FileNumber, [Validators.required, Validators.maxLength(250), this.globalSrv.noWhitespaceValidator, Validators.pattern(this.regexpNumber)]],
        FinancialYear: [this.model.FinancialYear, [Validators.required]],
        OD: [this.model.OD, [Validators.required]],
        ODTime: [this.model.ODTime, [Validators.required]],
        OfferDeadline: [''],
        PrimaryInsuranceValue: [this.model.PrimaryInsuranceValue, [Validators.maxLength(250)]],
        Booklet: ['', [FileValidator.validate]],
        TenderMethodId: [this.model.TenderMethodId, [Validators.required]],
        HaveMaintenanceContract: [this.model.HaveMaintenanceContract, [Validators.required]],
        MaintenanceContractValue: [this.model.MaintenanceContractValue],
        AcceptRetail: [this.model.AcceptRetail, [Validators.required]],
        HaveAlternativeOffers: [this.model.HaveAlternativeOffers, [Validators.required]],
        EvaluationSystemId: [this.model.EvaluationSystemId, [Validators.required]],
        MinimumAcceptancePointsForTechnicalOffer: [this.model.MinimumAcceptancePointsForTechnicalOffer],
        ETendersCategories: [this.model.ETendersCategories, [Validators.required]],
        CommentsAr: [this.model.CommentsAr],
        CommentsEn: [this.model.CommentsEn],
        ETenderManagerId: [this.model.ETenderManagerId, [Validators.required]],
        ETenderSpecialities: [this.model.Specialities],
        ETenderSuppliers: [this.model.Suppliers, [Validators.required]],
        TechnicalAdmins: [this.model.TechnicalAdmins, [Validators.required]],
        PurchasingAdmins: [this.model.PurchasingAdmins, [Validators.required]],
        ClarificationDurationStartDate: [''],
        CDStartDate: [this.model.CDStartDate, [Validators.required]],
        CDStartDateTime: [this.model.CDStartDateTime, [Validators.required]],
        ClarificationDurationEndDate: [''],
        CDEndDate: [this.model.CDEndDate, [Validators.required]],
        CDEndDateTime: [this.model.CDEndDateTime, [Validators.required]],
        PublishingDate: [''],
        PD: [this.model.PD, [Validators.required]],
        PDTime: [this.model.PDTime, [Validators.required]],
        CreatedBy: [this.model.CreatedBy],
        CreationDate: [this.model.CreationDate],
        ETenderCreatorId: [this.model.ETenderCreatorId],
        CancellationReason: [this.model.CancellationReason],
        Status: [this.model.Status],
        IsNotoficationSent: [this.model.IsNotoficationSent],
      });
    }
    if (this.TenderType == ETenderTypes.Quotations) {
      this.createTenderForm = this.formBuilder.group({
        Id: [this.model.Id],
        Language: [this.language, [Validators.required]],
        TenderTypeId: [this.TenderType, [Validators.required]],
        TitleAR: [this.model.TitleAR],
        TitleEN: [this.model.TitleEN],
        SessionPlaceAR: [this.model.SessionPlaceAR],
        SessionPlaceEN: [this.model.SessionPlaceEN],
        FileNumber: [this.model.FileNumber, [Validators.required, Validators.maxLength(250), this.globalSrv.noWhitespaceValidator, Validators.pattern(this.regexpNumber)]],
        FinancialYear: [this.model.FinancialYear, [Validators.required]],
        AcceptRetail: [this.model.AcceptRetail, [Validators.required]],
        HaveAlternativeOffers: [this.model.HaveAlternativeOffers, [Validators.required]],
        EvaluationSystemId: [this.model.EvaluationSystemId, [Validators.required]],
        MinimumAcceptancePointsForTechnicalOffer: [this.model.MinimumAcceptancePointsForTechnicalOffer],
        ETendersCategories: [this.model.ETendersCategories, [Validators.required]],
        Booklet: ['', [FileValidator.validate]],
        CommentsAr: [this.model.CommentsAr],
        CommentsEn: [this.model.CommentsEn],
        ETenderManagerId: [this.model.ETenderManagerId, [Validators.required]],
        TechnicalAdmins: [this.model.TechnicalAdmins, [Validators.required]],
        PurchasingAdmins: [this.model.PurchasingAdmins, [Validators.required]],
        ETenderSuppliers: [null],
        ETenderSpecialities: [null],
        ClarificationDurationStartDate: [''],
        CDStartDate: [this.model.CDStartDate, [Validators.required]],
        CDStartDateTime: [this.model.CDStartDateTime, [Validators.required]],
        ClarificationDurationEndDate: [''],
        CDEndDate: [this.model.CDEndDate, [Validators.required]],
        CDEndDateTime: [this.model.CDEndDateTime, [Validators.required]],
        PublishingDate: [''],
        PD: [this.model.PD, [Validators.required]],
        PDTime: [this.model.PDTime, [Validators.required]],
        CreatedBy: [this.model.CreatedBy],
        CreationDate: [this.model.CreationDate],
        ETenderCreatorId: [this.model.ETenderCreatorId],
        CancellationReason: [this.model.CancellationReason],
        Status: [this.model.Status],
        IsNotoficationSent: [this.model.IsNotoficationSent],
      });
    }

    if (this.TenderType == ETenderTypes.Practice) {
      this.createTenderForm = this.formBuilder.group({
        Id: [this.model.Id],
        Language: [this.language, [Validators.required]],
        TenderTypeId: [this.TenderType, [Validators.required]],
        TitleAR: [this.model.TitleAR],
        TitleEN: [this.model.TitleEN],
        SessionPlaceAR: [this.model.SessionPlaceAR],
        SessionPlaceEN: [this.model.SessionPlaceEN],
        TenderNumber: [this.model.TenderNumber, [Validators.maxLength(250), Validators.pattern(this.regexpNumber)]],
        FileNumber: [this.model.FileNumber, [Validators.required, Validators.maxLength(250), this.globalSrv.noWhitespaceValidator, Validators.pattern(this.regexpNumber)]],
        FinancialYear: [this.model.FinancialYear, [Validators.required]],
        OD: [this.model.OD, [Validators.required]],
        ODTime: [this.model.ODTime, [Validators.required]],
        OfferDeadline: [''],
        AcceptRetail: [this.model.AcceptRetail, [Validators.required]],
        HaveAlternativeOffers: [this.model.HaveAlternativeOffers, [Validators.required]],
        EvaluationSystemId: [this.model.EvaluationSystemId, [Validators.required]],
        MinimumAcceptancePointsForTechnicalOffer: [this.model.MinimumAcceptancePointsForTechnicalOffer],
        ETendersCategories: [this.model.ETendersCategories, [Validators.required]],
        Booklet: ['', [FileValidator.validate]],
        CommentsAr: [this.model.CommentsAr],
        CommentsEn: [this.model.CommentsEn],
        ETenderManagerId: [this.model.ETenderManagerId, [Validators.required]],
        ETenderSpecialities: [this.model.Specialities],
        ETenderSuppliers: [this.model.Suppliers, [Validators.required]],
        TechnicalAdmins: [this.model.TechnicalAdmins, [Validators.required]],
        PurchasingAdmins: [this.model.PurchasingAdmins, [Validators.required]],
        ClarificationDurationStartDate: [''],
        CDStartDate: [this.model.CDStartDate, [Validators.required]],
        CDStartDateTime: [this.model.CDStartDateTime, [Validators.required]],
        ClarificationDurationEndDate: [''],
        CDEndDate: [this.model.CDEndDate, [Validators.required]],
        CDEndDateTime: [this.model.CDEndDateTime, [Validators.required]],
        PublishingDate: [''],
        PD: [this.model.PD, [Validators.required]],
        PDTime: [this.model.PDTime, [Validators.required]],
        CreatedBy: [this.model.CreatedBy],
        CreationDate: [this.model.CreationDate],
        ETenderCreatorId: [this.model.ETenderCreatorId],
        CancellationReason: [this.model.CancellationReason],
        Status: [this.model.Status],
        IsNotoficationSent: [this.model.IsNotoficationSent],
      });
    }
    if (this.TenderType == ETenderTypes.PublicBidding) {
      this.createTenderForm = this.formBuilder.group({
        Id: [this.model.Id],
        Language: [this.model.Language, [Validators.required]],
        TenderTypeId: [this.TenderType, [Validators.required]],
        TitleAR: [this.model.TitleAR],
        TitleEN: [this.model.TitleEN],
        Date: [this.model.Date, [Validators.required]],
        Time: [this.model.Time, [Validators.required]],
        BookletPrice: [this.model.BookletPrice, [Validators.required, Validators.maxLength(10)]],
        InsuranceValue: [this.model.InsuranceValue, [Validators.required, Validators.maxLength(10)]],
        SessionPlaceAR: [this.model.SessionPlaceAR],
        SessionPlaceEN: [this.model.SessionPlaceEN],
        GeneralTermsAR: [this.model.GeneralTermsAR],
        GeneralTermsEN: [this.model.GeneralTermsEN],
        Booklet: ['', [FileValidator.validate]],
        ETendersCategories: [this.model.ETendersCategories, [Validators.required]],
        ETenderSpecialities: [null],
        ETenderSuppliers: [null],
        TechnicalAdmins: [null],
        PurchasingAdmins: [null],
        PublishingDate: [this.model.PublishingDate],
        PD: [this.model.PD, [Validators.required]],
        PDTime: [this.model.PDTime, [Validators.required]],
        CreatedBy: [this.model.CreatedBy],
        CreationDate: [this.model.CreationDate],
        ETenderCreatorId: [this.model.ETenderCreatorId],
        CancellationReason: [this.model.CancellationReason],
        Status: [this.model.Status],
        IsNotoficationSent: [this.model.IsNotoficationSent],
      });
    }
    if (this.language !== undefined) {
      this.validateLanguageFields(this.language);
    }
    if (this.booklet && this.booklet.URL != undefined) {
      const BookletCopy = this.Validate.Booklet;
      BookletCopy.clearValidators();
      BookletCopy.setValue('');
      BookletCopy.updateValueAndValidity();
    }
  }

  get ETenderAttachmentType() {
    return ETenderAttachmentType;
  }
  get ETenderTypes() { return ETenderTypes; }
  get getMinTenderDate() {
    return this.MinTenderDate;
  }
  get getMinClarificationEndDate() {
    return this.MinClarificationEndDate;
  }
  get getMinClarificationStartDate() {
    return this.MinClarificationStartDate;
  }
  get getMinDeadlineDate() {
    return this.MinDeadlineDate;
  }
  get getMinPublishDate() {
    return this.MinPublishDate;
  }
  get getMinFinancialYear() {
    return this.MinFinancialYear;
  }
  loadLookups() {
    this.globalSrv.isLoaderEnabled = true;
    this.TenderTypes = [];
    this.lookupService.getTenderLookups().subscribe(d => {

      this.TenderTypes = d.Data.TenderTypes;
      this.TenderMethods = d.Data.TenderMethods;
      this.EvaluationSystems = d.Data.EvaluationSystems;
      this.globalSrv.isLoaderEnabled = false;
      this.setFormMode();
    });
    this.etenderSrv.GetCategories().subscribe(c => {
      this.categoriesList = c.Data.map(function (e) {
        e.NameAR = e.Code + ' ' + e.NameAR;
        e.NameEN = e.Code + ' ' + e.NameEN;

        return e;

      });

    });
    this.etenderSrv.GetTenderManagers().subscribe(d => {
      this.ETenderManagers = d.Data;
    });
    this.languages = [{ Id: 1, NameEN: 'Arabic', NameAR: 'العربية' },
    { Id: 2, NameEN: 'English', NameAR: 'الانجليزية' },
    { Id: 3, NameEN: 'Both', NameAR: 'العربية والانجليزية' }];

  }
  languageChanged(num) {
    this.language = num.target.value;
    this.validateLanguageFields(this.language);
  }
  validateLanguageFields(num) {
    this.TitleARFormContol.setValidators(num != 2 ? [Validators.required, this.globalSrv.noWhitespaceValidator] : null);
    this.TitleARFormContol.setValue(num != 2 ? this.TitleARFormContol.value : null);
    this.TitleENFormContol.setValidators(num != 1 ? [Validators.required, this.globalSrv.noWhitespaceValidator] : null);
    this.TitleENFormContol.setValue(num != 1 ? this.TitleENFormContol.value : null);
    this.SessionPlaceARFormContol.setValidators(num != 2 ? [Validators.required, this.globalSrv.noWhitespaceValidator] : null);
    this.SessionPlaceARFormContol.setValue(num != 2 ? this.SessionPlaceARFormContol.value : null);
    this.SessionPlaceENFormContol.setValidators(num != 1 ? [Validators.required, this.globalSrv.noWhitespaceValidator] : null);
    this.SessionPlaceENFormContol.setValue(num != 1 ? this.SessionPlaceENFormContol.value : null);
    if (this.TenderType == ETenderTypes.PublicBidding) {
      this.GeneralTermsARFormContol.setValidators(num != 2 ? [Validators.required, this.globalSrv.noWhitespaceValidator] : null);
      this.GeneralTermsENFormContol.setValidators(num != 1 ? [Validators.required, this.globalSrv.noWhitespaceValidator] : null);
      this.GeneralTermsARFormContol.setValue(num != 2 ? this.GeneralTermsARFormContol.value : null);
      this.GeneralTermsENFormContol.setValue(num != 1 ? this.GeneralTermsENFormContol.value : null);
      this.GeneralTermsARFormContol.updateValueAndValidity();
      this.GeneralTermsENFormContol.updateValueAndValidity();
    } else {
      if (this.TenderType != null) {
        this.CommentsArFormContol.setValue(num != 2 ? this.CommentsArFormContol.value : null);
        this.CommentsEnFormContol.setValue(num != 1 ? this.CommentsEnFormContol.value : null);
        this.CommentsArFormContol.updateValueAndValidity();
        this.CommentsEnFormContol.updateValueAndValidity();
      }
    }
    this.TitleARFormContol.updateValueAndValidity();
    this.TitleENFormContol.updateValueAndValidity();
    this.SessionPlaceARFormContol.updateValueAndValidity();
    this.SessionPlaceENFormContol.updateValueAndValidity();
  }
  tenderTypeChanged(num) {
    if (num.target.value != 'undefined') {
      this.TenderType = num.target.value;
      this.buildForm(0);
    }
  }
  evaluationSystemIdChanged(num) {
    this.MinimumAcceptancePointsForTechnicalOfferFormContol.setValidators(num.target.value == 1 ? [Validators.required, Validators.maxLength(10)] : null);
    this.MinimumAcceptancePointsForTechnicalOfferFormContol.setValue(num.target.value == 1 ? this.MinimumAcceptancePointsForTechnicalOfferFormContol.value : null);
    this.MinimumAcceptancePointsForTechnicalOfferFormContol.updateValueAndValidity();
  }
  CategoriesChanged() {
    if (this.TenderType != null && this.TenderType != ETenderTypes.PublicBidding) {
      if (this.Validate.ETendersCategories && this.Validate.ETendersCategories.value != null) {
        const cats = this.Validate.ETendersCategories.value.map(function (e) {
          return e.Id;
        });
        if (!deepEqual(cats, this.oldCats)) {
          this.oldCats = cats;
          this.createTenderForm.get('TechnicalAdmins').setValue('');
          this.createTenderForm.get('PurchasingAdmins').setValue('');
          this.createTenderForm.get('ETenderSuppliers').setValue('');
          this.createTenderForm.get('ETenderSpecialities').setValue('');
          this.globalSrv.isLoaderEnabled = true;
          this.GetCategoriesDataByIds();
        }

      }

    }
  }
  SpecialitiesChanged() {
    if (this.Validate.ETenderSpecialities && this.Validate.ETenderSpecialities.value != null) {
      let specsIds: number[];
      if (this.Validate.ETenderSpecialities.value != '') {
        specsIds = this.Validate.ETenderSpecialities.value.map(function (e) {
          return e.Id;
        });
      }
      if (!deepEqual(specsIds, this.oldSpecs)) {
        this.suppliersList = [];
        this.oldSpecs = specsIds;
        if (specsIds) {
          this.globalSrv.isLoaderEnabled = true;
          this.supplierService.GetSuppliersBySpecialitiesId(this.oldSpecs).subscribe(c => {
            this.suppliersList = c.Data;
            this.createTenderForm.get('ETenderSuppliers').setValue('');
            if (this.model != null && this.model.ETenderSuppliers != null && this.model.ETenderSuppliers.length > 0
              && (this.TenderType == ETenderTypes.LimitedTender || this.TenderType == ETenderTypes.Practice)) {
              let supplierIds: string[] = [];
              supplierIds = this.model.ETenderSuppliers.map(function (e) { return e.Supplier.UserId; });
              this.model.Suppliers = this.suppliersList.filter(e => supplierIds.includes(e.UserId));
              this.model.ETenderSuppliers = [];
              this.buildForm(1);
            }
            this.globalSrv.isLoaderEnabled = false;
          });
        }
      }
    }
  }
  get Validate() {
    return this.createTenderForm.controls;
  }
  async AddAttachmentFile(event, currFormControl, docName, attachmentType: ETenderAttachmentType, progressVariableName) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      const errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(errorMessage);
      const invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = '';
      window.scrollTo(0, 0);
      return false;
    }

    if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      const errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileSize').toPromise();
      this.alertService.error(errorMessage);
      const invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = '';
      window.scrollTo(0, 0);
      return false;

    }

    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ETenderUploadsFolder);
    this.fileService.fileUploaderForAdmin(formData).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);
          this[progressVariableName] = percentDone;
          currFormControl.setErrors({ invalid: true });

        } else if (event instanceof HttpResponse) {
          const jsonResponse = event.body.Data;
          const Url = jsonResponse.Url;
          const attachment = new ETendersAttachmentDTO();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;
          this.CteateTenderAttachments = this.CteateTenderAttachments.filter(h => h.AttachmentType !== attachmentType);
          this.CteateTenderAttachments.push(attachment);
          currFormControl.setErrors(null);
        }
      }
    );
  }
  isGreaterThanDate(date1: Date, date2: Date): Boolean {
    let isGreaterThanDate = false;
    if (date2 != null) {
      isGreaterThanDate = new Date(date1) >= new Date(date2);
    }
    return isGreaterThanDate;
  }
  onSubmit() {
    this.submitted = true;
    if (this.createTenderForm.get('PD') != null && this.createTenderForm.get('PD').value) {
      const selectedDate = this.createTenderForm.get('PD').value
        .toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
      const selectedTime = this.createTenderForm.get('PDTime').value
        .toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
      const fullDate = selectedDate + ', ' + selectedTime;
      this.createTenderForm.controls.PublishingDate.setValue(fullDate);
    }
    if (this.createTenderForm.get('CDEndDate') != null && this.createTenderForm.get('CDEndDate').value) {
      const selectedDate = this.createTenderForm.get('CDEndDate').value
        .toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
      const selectedTime = this.createTenderForm.get('CDEndDateTime').value
        .toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
      const fullDate = selectedDate + ', ' + selectedTime;
      this.createTenderForm.controls.ClarificationDurationEndDate.setValue(fullDate);

      this.showPublishDateGreaterThanEndDateMessage =
        this.isGreaterThanDate(this.createTenderForm.controls.PublishingDate.value,
          this.createTenderForm.controls.ClarificationDurationEndDate.value);
    }
    if (this.createTenderForm.get('CDStartDate') != null && this.createTenderForm.get('CDStartDate').value) {
      const selectedDate = this.createTenderForm.get('CDStartDate').value
        .toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
      const selectedTime = this.createTenderForm.get('CDStartDateTime').value
        .toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
      const fullDate = selectedDate + ', ' + selectedTime;
      this.createTenderForm.controls.ClarificationDurationStartDate.setValue(fullDate);

      this.showStartDateGreaterThanEndDateMessage =
        this.isGreaterThanDate(this.createTenderForm.controls.ClarificationDurationStartDate.value,
          this.createTenderForm.controls.ClarificationDurationEndDate.value);
      this.showPublishDateGreaterThanStartDateMessage =
        this.isGreaterThanDate(this.createTenderForm.controls.PublishingDate.value,
          this.createTenderForm.controls.ClarificationDurationStartDate.value);
    }
    if (this.createTenderForm.get('OD') != null && this.createTenderForm.get('OD').value) {
      const selectedDate = this.createTenderForm.get('OD').value
        .toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
      const selectedTime = this.createTenderForm.get('ODTime').value
        .toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
      const fullDate = selectedDate + ', ' + selectedTime;
      this.createTenderForm.controls.OfferDeadline.setValue(fullDate);

      this.showEndDateGreaterThanOfferDeadLineMessage =
        this.isGreaterThanDate(this.createTenderForm.controls.ClarificationDurationEndDate.value,
          this.createTenderForm.controls.OfferDeadline.value);
      this.showStartDateGreaterThanOfferDeadLineMessage =
        this.isGreaterThanDate(this.createTenderForm.controls.ClarificationDurationStartDate.value,
          this.createTenderForm.controls.OfferDeadline.value);
      this.showPublishDateGreaterThanOfferDeadLineMessage =
        this.isGreaterThanDate(this.createTenderForm.controls.PublishingDate.value,
          this.createTenderForm.controls.OfferDeadline.value);
      this.createTender.nativeElement.querySelectorAll('.OD')[0].focus();
    }
    if (this.createTenderForm.invalid || this.showStartDateGreaterThanOfferDeadLineMessage ||
      this.showEndDateGreaterThanOfferDeadLineMessage || this.showStartDateGreaterThanEndDateMessage
      || this.showPublishDateGreaterThanEndDateMessage || this.showPublishDateGreaterThanOfferDeadLineMessage
      || this.showPublishDateGreaterThanStartDateMessage) {
      this.navigaeToFirstInvalid(this.createTender);
      return;
    }

    this.model = this.createTenderForm.getRawValue();
    if (this.createTenderForm.get('Time') != null && this.createTenderForm.get('Time').value) {
      this.model.Time = this.createTenderForm.get('Time').value.toLocaleTimeString('en-US', { hour12: false });
    }
    if (this.createTenderForm.get('FinancialYear') != null && this.createTenderForm.get('FinancialYear').value) {
      this.model.FinancialYear = this.createTenderForm.get('FinancialYear').value.getFullYear();
    }
    if (this.createTenderForm.get('ETendersCategories').value != null) {
      const admins: ETendersCategoriesAdminDTO[] = [];
      if (this.createTenderForm.get('TechnicalAdmins').value != null && this.createTenderForm.get('TechnicalAdmins').value.length > 0) {
        this.createTenderForm.controls.TechnicalAdmins.value.map((currItem) => {
          this.TechnicaloAdminsOriginalList.filter(p => p.SPGroupUserId === currItem.SPGroupUserId).forEach(element => {
            admins.push({
              Id: '', Category: null, SPGroupUserName: '', CategoryId: element.CategoryId,
              SPGroupUserId: currItem.SPGroupUserId, SPGroupUser: null
            });
          });
        });
      }
      if (this.createTenderForm.get('PurchasingAdmins').value != null && this.createTenderForm.get('PurchasingAdmins').value.length > 0) {
        this.createTenderForm.controls.PurchasingAdmins.value.map((currItem) => {
          this.PurchasingAdminsOriginalList.filter(p => p.SPGroupUserId == currItem.SPGroupUserId).forEach(element => {
            admins.push({
              Id: '', Category: null, SPGroupUserName: '', CategoryId: element.CategoryId,
              SPGroupUserId: currItem.SPGroupUserId, SPGroupUser: null
            });
          });
        });
      }
      if (admins.length === 0) {
        this.createTenderForm.controls.ETendersCategories.value.map(function (currItem) {
          admins.push({ Id: '', Category: null, SPGroupUserName: '', CategoryId: currItem.Id, SPGroupUser: null });
        });
      }
      this.model.ETendersCategoriesAdmin = admins;
    }
    if (this.createTenderForm.get('ETenderSuppliers').value != null && this.createTenderForm.get('ETenderSuppliers').value.length > 0) {
      this.model.ETenderSuppliers = this.createTenderForm.controls.ETenderSuppliers.value.map(function (currItem) {
        const supplier = {} as ETenderSupplierDTO;
        supplier.SupplierId = currItem.UserId;
        return supplier;
      });
    } else {
      if (this.model.TenderTypeId != ETenderTypes.PublicBidding) {
        this.model.ETenderSuppliers = this.suppliersList.map(function (currItem) {
          const supplier = {} as ETenderSupplierDTO;
          supplier.SupplierId = currItem.UserId;
          return supplier;
        });
      }
    }
    this.model.ETendersAttachments = this.CteateTenderAttachments;
    if (this.model.Status == null) {
      this.model.Status = 1;
    }
    this.globalSrv.isLoaderEnabled = true;
    if (this.model.Id === '') {
      this.model.Id = null;
      this.model.CreatedBy = this.authSrevice.currentUserValue.Email;
      this.model.IsNotoficationSent = false;
      this.etenderSrv.AddEtenderForm(this.model).subscribe(
        (data: ResponseObject) => {
          this.responseObj = data;
          if (this.responseObj.Success) {
            this.createTenderForm.reset();
            this.showRequest = false;
            this.IsSuccess = true;
            this.globalSrv.isLoaderEnabled = false;
            this.translate.get('ADMIN_USER.E_TENDER_FORM.SUCCESS_MSG').subscribe((response: string) => {
              this.message = response;
            });
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }
        });
    } else {
      if (this.model.ETendersAttachments == null) {
        this.booklet.URL = this.booklet.URL.replace(this.uploadUrl, '');
        this.model.ETendersAttachments[0] = this.booklet;
      }
      this.etenderSrv.EditEtenderForm(this.model).subscribe(
        (data: ResponseObject) => {
          this.responseObj = data;
          if (this.responseObj.Success) {
            this.createTenderForm.reset();
            this.showRequest = false;
            this.IsSuccess = true;
            this.globalSrv.isLoaderEnabled = false;
            this.translate.get('ADMIN_USER.E_TENDER_FORM.EDIT_SUCCESS_MSG').subscribe((response: string) => {
              this.message = response;
            });
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = false;
            this.IsSuccess = true;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }
        });
    }
  }
  navigaeToFirstInvalid(CurrentTabElementRef: ElementRef) {
    const invalidControls = CurrentTabElementRef.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length > 0) {
      for (let index = 0; index < invalidControls.length; index++) {
        const element = invalidControls[index];
        if (element.localName != 'div') {
          element.focus();
          return;
        }
      }
    }
  }
}
